import i18n from '@fiverr/i18n/singleton';
import axios from 'axios';
import { isEmpty } from 'lodash';
import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import pathfinder from '@fiverr-private/pathfinder';
import { currencyFormat } from '@fiverr-private/localization';
import { logger } from '@fiverr-private/obs';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { OrderResponse, TranslationParams } from '../types';

export const ShareYourExperienceCardImpl = {
    getJobInfo: async ({ context, externalServicesInfo, userData }) => {
        try {
            const { currency, locale } = context;
            const url = `${externalServicesInfo.reviewsKimera.url}/orders/last_order_without_review`;
            const fetcher = () => axios.get<OrderResponse>(url);
            const { data } = await statsFunctionWrapper(fetcher, 'jtbd.order_updates.get_last_order_without_review')();

            if (!data?.order || isEmpty(data.order)) {
                return {
                    shouldDisplayJob: false,
                };
            }

            const {
                order: { duration, encrypted_id, paid_amount, profile_image_url, sellers_fullname },
            } = data;

            const price = currencyFormat({
                value: paid_amount / 100,
                currencyCode: currency,
            });

            const translationParams: TranslationParams = {
                $scope: locale,
                sellerName: sellers_fullname,
                price,
                duration,
            };

            return {
                shouldDisplayJob: true,
                dismissInfo: {
                    isDismissible: true,
                },
                headerText: i18n.t('jobs_tbd.share_your_experience.header_text', translationParams),
                jobPages: [
                    {
                        title: i18n.t('jobs_tbd.share_your_experience.title', translationParams),
                        subtitle: i18n.t('jobs_tbd.share_your_experience.subtitle', translationParams),
                        iconUrl: profile_image_url,
                        ctaText: i18n.t('jobs_tbd.share_your_experience.cta', translationParams),
                    },
                ],
                clickAction: {
                    type: 'link',
                    href: pathfinder(
                        'new_user_order_rating',
                        {
                            username: userData.username,
                            order_id: encrypted_id,
                        },
                        {
                            query: { redirect_path: 'homepage' },
                        }
                    ),
                },
            };
        } catch (error: any) {
            logger.error(error, { description: 'Error fetching last order without review' });

            return {
                shouldDisplayJob: false,
            };
        }
    },
} satisfies EagerJobsTbdSdk;
